import React from 'react';
import PropTypes from 'prop-types';

import { flattenToAppURL } from '@plone/volto/helpers';
import { ConditionalLink } from '@plone/volto/components';
import {
  PriceRangeIndications,
  ItemDescription,
  ListingImage,
} from '@package/components';
import TagsView from './TagsView';
import config from '@plone/volto/registry';

const ExperienceItem = ({
  item = {},
  withTags = true,
  isEditMode,
  showMunicipality = true,
  showPrice = true,
}) => {
  const url = item['@id'].includes(config.settings.apiPath)
    ? flattenToAppURL(item['@id'])
    : item['@id'];

  let description = item.description;

  if (description && description.length > 110) {
    description = description.substring(0, 110) + '...';
  }
  return (
    <div className="item experience-item">
      <div className="item-title">
        <ConditionalLink
          to={flattenToAppURL(item['@id'])}
          title={item.title}
          condition={!isEditMode}
        >
          <h3>{item.title}</h3>
        </ConditionalLink>
      </div>

      <div className="item-border" />

      <div className="item-content">
        <ConditionalLink
          to={url}
          title={item.title}
          condition={!isEditMode}
          aria-hidden="true"
          role="presentation"
          tabIndex="-1"
        >
          <ListingImage item={item} />

          {withTags && item.thematic_area && (
            <TagsView subjects={[item.thematic_area.title]} />
          )}
          {showPrice && <PriceRangeIndications item={item} />}
        </ConditionalLink>
      </div>

      {showMunicipality && item.municipality?.title && (
        <div className="municipality">{item.municipality.title}</div>
      )}
      <ItemDescription item={item} />
    </div>
  );
};

ExperienceItem.propTypes = {
  item: PropTypes.object,
  withTags: PropTypes.bool,
};

export default ExperienceItem;
